export const ReadableKindType = Object.freeze({
  facebookPost: 'Facebook Post',
  instagramPost: 'Instagram Post',
  linkedinPost: 'LinkedIn Post',
  newsletter: 'Newsletter',
  facebookAds: 'Facebook Ads',
  gmbNewsPost: 'Google Unternehmensprofil Newspost',
  gmbProductDescription: 'Google Unternehmensprofil Produktbeschreibung',
  customerMailing: 'Kundenanschreiben',
  websiteText: 'Webseiten Text',
  interview: 'Interview'
})
